module.exports = __webpack_public_path__ + "img/services-buttons-add.d9f39534.svg";